const layoutConfig = {
  navHeight: '70px',
};

export { layoutConfig };
